import Divider from 'components/shared/Divider/Divider';

import AuthorizationApplied from '../AuthorizationApplied';
import CardOnFile from '../CardOnFile';

import BalanceBilling from './BalanceBilling';
import BillingMethod from './BillingMethod';
import PatientPortionCpt from './PatientPortionCpt';

const OutOfNetwork = ({ phase, onChange }) => {
  return (
    <div className="flex flex-col gap-4">
      <CardOnFile
        value={phase?.card_on_file?.route_to}
        onChange={(route_to) => onChange({ card_on_file: { route_to } })}
      />
      <Divider />
      <AuthorizationApplied
        value={phase?.authorization_applied?.route_to}
        onChange={(route_to) => onChange({ authorization_applied: { route_to } })}
      />
      <Divider />
      <BillingMethod
        value={phase?.billing_method}
        onChange={(next) => onChange({ billing_method: next })}
      />
      <Divider />
      <PatientPortionCpt
        value={phase?.patient_portion_cpt?.route_to}
        onChange={(route_to) => onChange({ patient_portion_cpt: { route_to } })}
      />
      <Divider />
      <BalanceBilling
        value={phase?.balance_billing?.enabled}
        onChange={(enabled) => onChange({ balance_billing: { enabled } })}
      />
    </div>
  );
};

export default OutOfNetwork;
